import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BsPerson, BsBoxArrowRight } from 'react-icons/bs';
import { BsSun, BsMoon } from 'react-icons/bs';
import { MdGTranslate } from 'react-icons/md';
import { FaAngleDown } from 'react-icons/fa';
import { translate } from '../../../utils/Common';
import ThemeContext from '../../../contexts/theme';
import LanguageSelector from '../LanguageSelector';
import styles from './UserMenu.module.css';

const UserMenu = ({ 
    isOpen, 
    onClose, 
    onProfileClick, 
    onLogout,
    variant = 'default' // 'default', 'sidebar', 'mobile'
}) => {
    const themeContext = React.useContext(ThemeContext);
    const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState('en');

    useEffect(() => {
        const langStorage = localStorage.getItem("language");
        if (langStorage) {
            setCurrentLanguage(langStorage);
        } else {
            const browserLang = window.navigator.language?.split("-")[0];
            const defaultLang = ['en', 'es', 'pt'].includes(browserLang) ? browserLang : 'en';
            setCurrentLanguage(defaultLang);
        }
    }, []);

    const handleLanguageClick = () => {
        setIsLanguageModalOpen(true);
        onClose();
    };

    const handleThemeToggle = () => {
        themeContext.toggleTheme();
        onClose();
    };

    const handleProfileClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onProfileClick) {
            onProfileClick();
        } else {
            onClose();
        }
    };

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        } else {
            onClose();
        }
    };

    if (!isOpen && !isLanguageModalOpen) return null;

    const menuClass = `${styles.userMenu} ${styles[variant]}`;
    const itemClass = variant === 'sidebar' ? styles.userMenuItemSidebar : styles.userMenuItem;

    return (
        <>
            {isOpen && (
                <div className={menuClass}>
                    {onProfileClick ? (
                        <button 
                            className={itemClass}
                            onClick={handleProfileClick}
                        >
                            <BsPerson className={styles.userMenuIcon} size={16} />
                            <span>{translate("navbar.profile")}</span>
                        </button>
                    ) : (
                        <Link 
                            to="/dashboard/profile" 
                            className={itemClass}
                            onClick={handleProfileClick}
                        >
                            <BsPerson className={styles.userMenuIcon} size={16} />
                            <span>{translate("navbar.profile")}</span>
                        </Link>
                    )}

                    <button 
                        className={itemClass}
                        onClick={handleLanguageClick}
                    >
                        <MdGTranslate className={styles.userMenuIcon} size={16} />
                        <span style={{ flex: 1, textAlign: 'left' }}>{translate("bottomNav.language")}</span>
                        <span style={{ 
                            fontSize: '11px', 
                            fontWeight: 700, 
                            color: 'var(--text-secondary)',
                            letterSpacing: '0.5px',
                            marginRight: '4px'
                        }}>
                            {currentLanguage.toUpperCase()}
                        </span>
                        <FaAngleDown style={{ 
                            fontSize: '10px', 
                            color: 'var(--text-secondary)',
                            transition: 'transform 0.2s ease'
                        }} />
                    </button>

                {variant === 'sidebar' ? (
                    <button 
                        className={styles.themeToggleWrapper}
                        onClick={handleThemeToggle}
                        aria-label={themeContext.theme === 'light' ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro'}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className={styles.themeToggleButton}>
                                {themeContext.theme === 'light' ? (
                                    <BsMoon className={styles.themeIcon} size={18} />
                                ) : (
                                    <BsSun className={styles.themeIcon} size={18} />
                                )}
                            </div>
                        </div>
                        <span className={styles.userMenuText}>{translate("bottomNav.theme")}</span>
                    </button>
                ) : (
                    <button 
                        className={itemClass}
                        onClick={handleThemeToggle}
                    >
                        {themeContext.theme === 'light' ? (
                            <BsMoon className={styles.userMenuIcon} size={16} />
                        ) : (
                            <BsSun className={styles.userMenuIcon} size={16} />
                        )}
                        <span>{translate("bottomNav.theme")}</span>
                    </button>
                )}

                <button 
                    className={itemClass}
                    onClick={handleLogout}
                >
                    <BsBoxArrowRight className={styles.userMenuIcon} size={16} />
                    <span>{translate("navbar.logout")}</span>
                </button>
                </div>
            )}

            <LanguageSelector 
                variant="menu" 
                isOpen={isLanguageModalOpen}
                onClose={() => setIsLanguageModalOpen(false)}
            />
        </>
    );
};

export default UserMenu;

